import LandingPage from './landing_page';

export default function OnboardingLandingPage() {
  return <LandingPage />;
}
